import { meetsMinVersion } from '@barso/shared';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { api } from './api/endpoints';

/**
 * Versions-Sperre der nativen App (P5): Läuft die Web-App innerhalb der Capacitor-Hülle (Android/iOS), wird die
 * eigene Version gegen die vom Server vorgegebene Mindestversion geprüft. In einem gewöhnlichen Browser (auch als
 * installierte PWA) liefert das immer `null` (keine Sperre): Dort gibt es keinen Store-Release, den man sperren
 * müsste, und `@capacitor/app` ist dort ohnehin ein No-op.
 */
export interface VersionGateResult {
  currentVersion: string;
  minVersion: string;
  storeUrl: string | null;
}

const STORE_URLS: Record<string, string | null> = {
  android: 'https://play.google.com/store/apps/details?id=io.basaro.app',
  // Die Apple-eigene numerische App-ID gibt es erst nach der ersten Veröffentlichung; bis dahin nur ein Hinweistext.
  ios: null,
};

/** `null`, wenn keine Sperre gilt (Browser/PWA, keine Mindestversion gesetzt, oder Version ausreichend). */
export async function checkNativeVersionGate(): Promise<VersionGateResult | null> {
  if (!Capacitor.isNativePlatform()) return null;
  const platform = Capacitor.getPlatform();
  const [info, server] = await Promise.all([App.getInfo(), api.version()]);
  const minVersion =
    platform === 'android' ? server.minMobileAndroidVersion : server.minMobileIosVersion;
  if (minVersion === null || meetsMinVersion(info.version, minVersion)) return null;
  return { currentVersion: info.version, minVersion, storeUrl: STORE_URLS[platform] ?? null };
}
